import { observable, runInAction } from 'mobx'
import ContactApi from '@api/sa_li/contact'
import LeaveMsgStore from '@common/ContactUs/LeaveMessage/store'
import { getMerchantInfo } from '@util'

class Store {
  @observable contactData = {}

  constructor() {
    this.leaveMsgStore = new LeaveMsgStore()
  }

  getContactList = async () => {
    const { data } = await ContactApi.contactList({
      merchant_id: getMerchantInfo().id
    })

    runInAction(() => {
      this.contactData = data || {}
    })
  }
}

export default Store
